import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class ImtSearch implements AnalyticsObject {
  name: string
  properties: ImtSearchProperties
  constructor(params: ImtSearchParams) {
    this.name = `IMT Search ${params.type}`
    this.properties = {
      corridor: {
        countryFrom: params.countryFrom,
        countryTo: params.countryTo,
        currencyFrom: params.currencyFrom,
        currencyTo: params.currencyTo,
        countries: `${params.countryFrom}-${params.countryTo}`,
        currencies: `${params.currencyFrom}-${params.currencyTo}`,
        amount: params.amount,
      },
    }
  }
}

interface ImtSearchProperties extends AnalyticsProperties {
  corridor: {
    countryFrom: string
    countryTo: string
    countries: string
    currencyFrom: string
    currencyTo: string
    currencies: string
    amount: number
  }
}

export interface ImtSearchParams {
  type: 'Form' | 'Prompt'
  countryFrom: string
  countryTo: string
  currencyFrom: string
  currencyTo: string
  payout?: string
  amount: number
}

export class ImtSearchFormField implements AnalyticsObject {
  name: string
  properties: ImtSearchFormFieldProperties
  constructor(properties: ImtSearchFormFieldProperties) {
    this.name = 'IMT Search Form Field'
    this.properties = properties
  }
}

export interface ImtSearchFormFieldProperties extends AnalyticsProperties {
  field: 'amount' | 'country_from' | 'country_to' | 'currency_from' | 'currency_to' | 'payout'
}
